<div *ngIf="isLoadingAppinfo" class="pad-20 pos-r" style="min-height: 100px;min-width:100px;contain-intrinsic-size: auto 100px;">
  <app-loader></app-loader>
  <!-- Loading App Info... -->
</div>
<div class="" *ngIf="!isLoadingAppinfo && !!AppInfo" style="content-visibility: auto;">
  <div class=" {{useType=='popup' ? 'grid-40-60-p':'grid-40-60'}}" style="height: 545px;">
    <div class="pad-30 border-right border-c desk-view" style="padding:40px; background: #FDF8EE;">
      <div class="flex">
        <div class="icon-40 mar-r-20" style="width: 45%!important;">
          <!-- fetchpriority="high" importance="high" loading="eager" -->
          <img src="https://storage.googleapis.com/airlift-images/loginpage_logo_1783666019.svg" class="width-100" >
        </div>
        <!-- <div class="flex flex-d-c" style="line-height: 1.3;">
          <div class="text-c font-18 f-w-500">{{AppInfo?.portal_name}}</div>
          <div class="font-10 f-w-500">{{AppInfo?.tag_line}}</div>
        </div> -->
      </div>
      <!-- <div> -->
      <div class="flex align-c justify-c pad-t-50 pad-b-20">
        <!-- style="height: 280px;width: 280px;" -->
              <img width="280" height="280" alt="Login page image" [src]="'https://storage.googleapis.com/airlift-images/dc1d734d1c60411bbccf2a00ab39a8b77f5fb48d_1782400618.png'" style="width: 100%;">

          <!-- style="content-visibility: auto; aspect-ratio: 1/1;display: block;"
          fetchpriority="high" importance="high" loading="eager" -->
      </div>
      <!-- </div> -->
               <div class="divider">
  <div class="line"></div>
  
  <div class="icon">
    <svg width="24" height="32" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 0C5.373 0 0 5.373 0 12C0 21 12 32 12 32C12 32 24 21 24 12C24 5.373 18.627 0 12 0ZM12 17.5C8.962 17.5 6.5 15.038 6.5 12C6.5 8.962 8.962 6.5 12 6.5C15.038 6.5 17.5 8.962 17.5 12C17.5 15.038 15.038 17.5 12 17.5Z" fill="#e7b864"/>
    </svg>
  </div>
  
  <div class="line"></div>
</div>
      <!-- </div> -->
      <div class="sub-c font-12 c-width" style="color:#243246!important;text-align: center;margin-top: 15px;width:100%;">
        Access rates from multiple liners, effortlessly<br>book shipments, and track them in real-time.
      </div>
    </div>

    <div class="pad-d-50 over-h {{projectType=='sent_email' || projectType=='reset_success' ? 'flex justify-c' : ''}}">
      <ng-container [ngTemplateOutlet]="loginTemplate" *ngIf="projectType=='login'"></ng-container>
      <ng-container [ngTemplateOutlet]="forgotPassword" *ngIf="projectType=='forgot'"></ng-container>
      <ng-container [ngTemplateOutlet]="emailSent" *ngIf="projectType=='sent_email'"></ng-container>
      <ng-container [ngTemplateOutlet]="resetPassword" *ngIf="projectType=='reset' && !!token"></ng-container>

      <ng-container [ngTemplateOutlet]="setPassword" *ngIf="projectType=='set_password'"></ng-container>

      <ng-container [ngTemplateOutlet]="resetSuccessTemplate" *ngIf="projectType=='reset_success'"></ng-container>
      <ng-container [ngTemplateOutlet]="invalidToken" *ngIf="projectType=='invalid_token_link'"> </ng-container>
      <ng-container [ngTemplateOutlet]="PasswordExit" *ngIf="projectType=='password_exit'"></ng-container>
      <ng-container [ngTemplateOutlet]="invalidPasswordlinkTemplate" *ngIf="projectType=='invalid_password_link'"></ng-container>

    </div>
  </div>
</div>

<ng-template #loginTemplate>
  <div class="d-f">
    <div class="icon-40 mar-r-20">
      <img src="https://storage.googleapis.com/airlift-images/loginpage_logo_1783666019.svg" class="width-100">
    </div>
    <div class="flex flex-d-c" style="line-height: 1.3;">
      <div class="text-c font-18 f-w-500">{{AppInfo?.portal_name}}</div>
      <div class="font-10 f-w-500">{{AppInfo?.tag_line}}</div>
    </div>
  </div>

  <div class="mar-b-30">
    <div class="font-16 f-w-500 pad-b-5">Log in to your Account</div>
    <div class="sub-cc font-12">Welcome back to {{AppInfo?.portal_name}}!</div>
  </div>

  <!-- Email -->
  <div>
    <form [formGroup]="loginFormGroup">
      <div class="mar-b-20" *ngIf="!submittedOTPRequest">
        <div class="input-bc flex width-400 text-field pos-r {{!!emailErrorCallback?'shake':''}}">
          <input style="background: #F6F2E9;border: 0.5px solid #E8A23DB2 !important;" type="text" placeholder=" " formControlName="email" type="email" (blur)="checkUserExist()"
            class="pad-10 text-base {{!emailErrorCallback ? 'valid' : 'invalid'}} {{loginFormGroup.get('email')?.value.length > 0 ? '':'border-n'}}">
          <span class="{{!emailErrorCallback ? 'valid-c' : 'invalid-c'}} font-s wid-90 overflow-e email-ph"></span>
          <div class="pos-a" style="top:12px;right: 12px;" *ngIf="!!isCheckingMailid">
            <mat-spinner [diameter]="20"></mat-spinner>
          </div>
        </div>
        <div class="error-span mar-t-10 " *ngIf="!!emailErrorCallback">{{emailErrorCallback}}</div>
      </div>

      <div *ngIf="submittedOTPRequest && loginTypeOtp" class="mar-b-20">
        We’ve sent an OTP to your email <span class="head-c f-w-500">{{loginFormGroup.get('email')?.value}}</span>.
        <span class="font-12 pointer" *ngIf="submittedOTPRequest && loginTypeOtp" (click)="changeMailId()">(<span
            class="link-c">Not mine</span>)</span>
      </div>

      <div class="mar-b-30" *ngIf="submittedOTPRequest && loginTypeOtp">
        <div
          class="input-bc flex  width-400 text-field {{!!otpErrorCallback ? 'shake' : ''}} {{!!loginFormGroup.get('otp')?.value.length ? 'bg-none':''}}">
          <div class="password-input-container width-100">
            <input style="background: #F6F2E9;border: 0.5px solid #E8A23DB2 !important;" placeholder=" " formControlName="otp"
              class="pad-10 height-100 text-base {{!otpErrorCallback ? 'valid' : 'invalid'}} {{!!loginFormGroup.get('otp')?.value.length ? 'border-n':''}}"
              type="number">
            <span class="{{!otpErrorCallback ? 'valid-c' : 'invalid-c'}} font-s wid-90 overflow-e otp-ph"></span>
          </div>
        </div>
        <div class="error-span mar-t-10" *ngIf="!!otpErrorCallback">{{otpErrorCallback}}</div>
      </div>

      <div class="mar-b-30" *ngIf="!loginTypeOtp && !setPasswordPending">
        <div
          class="input-bc flex  width-400 text-field {{!!passwordErrorCallback ? 'shake' : ''}} {{loginFormGroup.get('password')?.value.length > 0 ? 'bg-none':''}}">
          <div class="password-input-container width-100">
            <input style="background: #F6F2E9;border: 0.5px solid #E8A23DB2 !important;" placeholder=" " formControlName="password" name="password"
              class="pad-10 height-100 text-base {{!passwordErrorCallback ? 'valid' : 'invalid'}} {{loginFormGroup.get('password')?.value.length > 0 ? '':'border-n'}}"
              type="{{passwordOpen ? 'text' : 'password'}}">
            <span class="{{!passwordErrorCallback ? 'valid-c' : 'invalid-c'}} font-s wid-90 overflow-e pass-ph"></span>
            <div class="visibility-icon-container pointer" (click)="passwordOpen=!passwordOpen">
              <div class="material-symbols-outlined icon-20">{{passwordOpen ? 'visibility' : 'visibility_off'}}</div>
            </div>
          </div>
        </div>

        <div class="error-span mar-t-10" *ngIf="!!passwordErrorCallback">{{passwordErrorCallback}}</div>
      </div>
      <div *ngIf="!loginTypeOtp && setPasswordPending" class="mar-b-30 pad-10 sub-c">
        No password has been created
      </div>
      <div class="mar-b-30" *ngIf="!!loginTypeOtp">

      </div>
      <div class="flex align-c justify-space-between mar-b-30">
        <div class="font-14 text-c pointer" (click)="onForgetPassword()" *ngIf="!loginTypeOtp">Forgot Password?</div>


        <div class="{{otpResendTimer?'sub-c font-12 pointer-h':'primary-c font-14 pointer'}}"
          (click)="otpResendTimer?'':validateForOTP()" *ngIf="loginTypeOtp && submittedOTPRequest && gotOTP">
          {{otpResendTimer?'Resend OTP in':'Resend OTP ?'}}
          {{!!otpResendTimer?otpResendTimer:''}} {{otpResendTimer?' secs':''}}</div>

        <button *ngIf="!loginTypeOtp && !setPasswordPending" mat-button type="submit" name="submit"
          class=" {{!!spinner ? 'width-130 col-d text-c' : 'width-100px white btn-bg'}}" (click)="login()"
          [disabled]="isSubmiting || isCheckingMailid">
          <div class="flex align-c">
            <div *ngIf="!!spinner" class="mar-r-10">
              <mat-spinner [diameter]="20" strokeWidth="2"></mat-spinner>
            </div>
            <div>{{!!spinner ? 'Verifying' : 'Log in'}}</div>
          </div>
        </button>

        <button *ngIf="!loginTypeOtp && setPasswordPending" mat-flat-button type="submit" color="primary"
          (click)="projectType='set_password';">
          <div class="flex align-c">
            <div>Set Password</div>
          </div>
        </button>

        <button *ngIf="loginTypeOtp" mat-button type="submit"
          class="{{loginTypeOtp && submittedOTPRequest && gotOTP?'':'width-100'}} {{!!spinner ? 'width-130 col-d text-c' : 'width-100px white btn-bg'}}"
          (click)="gotOTP?login():validateForOTP()" [disabled]="isSubmiting || isCheckingMailid">
          <div class="flex align-c">
            <div *ngIf="!!spinner" class="mar-r-10">
              <mat-spinner [diameter]="20" strokeWidth="2"></mat-spinner>
            </div>
            <div>{{!!spinner  && !gotOTP? 'Requesting OTP' : (gotOTP?'Verify'+(spinner?'ing':''):'Get OTP')}}</div>
          </div>
        </button>
      </div>
    </form>
  </div>
  <div class="border-t border-c mar-b-30 pos-r">
    <span class="pos-a pad-5 bg-white sub-c font-12" style="left: calc(50% - 15px);top: -15px;">OR</span>
  </div>
  <button mat-stroked-button class="width-100 mar-b-30 head-c font-14" (click)="changeLoginType()">Login with
    {{!loginTypeOtp?'OTP':'your Password'}}</button>
  <div (click)="signup()">
    <div>New User? <span class="text-c pointer mar-l-10">Create an Account</span></div>
  </div>
</ng-template>


<ng-template #forgotPassword>

  <div class="d-f">
    <div class="icon-40 mar-r-20">
      <img src="https://app.atmavaan.com/uploads/{{AppInfo?.logo}}" class="width-100">
    </div>
    <div class="flex flex-d-c" style="line-height: 1.3;">
      <div class="text-c font-18 f-w-500">{{AppInfo?.portal_name}}</div>
      <div class="font-10 f-w-500">{{AppInfo?.tag_line}}</div>
    </div>
  </div>

  <div>
    <div class="mar-b-30">
      <div class="font-18 f-w-500 pad-b-5">Forgot Password</div>
      <div class="sub-c font-12">Reset your Password</div>
    </div>

    <div class="input-bc flex  width-400 mar-b-30 text-field {{!!errorMessage ? 'shake' : ''}}">
      <input style="background: #F6F2E9;border: 0.5px solid #E8A23DB2 !important;"
        class="pad-10 text-base height-100 {{!errorMessage ? 'valid' : 'invalid'}}  {{resetEmail.value.length > 0 ? '':'border-n'}} width-100"
        type="email" [formControl]="resetEmail" placeholder="Ex. somename@example.com">
      <span class="{{!errorMessage ? 'valid-c' : 'invalid-c'}} font-s reg-ph"></span>
    </div>

    <div class="flex align-c justify-space-between mar-b-20">
      <!-- <button mat-button class="text-c width-200" (click)="projectType='login'" type="submit">Back to
        Login</button> -->
      <div class="font-14 text-c pointer" (click)="projectType='login';backToLogin()">Back to Login</div>
      <button mat-button class=" {{!!spinner ? 'width-130 col-d text-c' : ' btn-bg width-200 white'}}"
        (click)="resetLink()" type="submit">
        <div class="flex align-c">
          <div *ngIf="!!spinner" class="mar-r-10">
            <mat-spinner [diameter]="20" strokeWidth="2"></mat-spinner>
          </div>
          <div>{{!!spinner ? 'Verifying' : 'Request Reset Link'}}</div>
        </div>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #emailSent>

  <div>
    <div class="d-f" style="position: relative;left: -20px;">
      <div class="icon-40 mar-r-20">
        <img src="https://app.atmavaan.com/uploads/{{AppInfo?.logo}}" class="width-100">
      </div>
      <div class="flex flex-d-c" style="line-height: 1.3;">
        <div class="text-c font-18 f-w-500">{{AppInfo?.portal_name}}</div>
        <div class="font-10 f-w-500">{{AppInfo?.tag_line}}</div>
      </div>
    </div>

    <div class="flex flex-d-c" style="position: relative;left: -20px;">
      <div class="font-18 f-w-500 pad-b-5">Forgot Password</div>
      <div class="sub-c font-12">Reset your Password</div>
    </div>

    <div class="flex  align-c justify-c flex-d-c" style="position: relative;top: 10%;">

      <div class="mar-b-30"><img src="{{filePath}}Group_34449_svg_453_2024-01-31_13:57:12.svg" alt="">
      </div>
      <div class="text-a-c font-20 head-c mar-b-10">We have sent a link to your email</div>
      <div class="font-16 mar-b-20">"{{resetEmail.value}}"</div>

      <div class="text-a-c font-12 sub-cc mar-b-20 width-370">
        Check your email for a secure link to reset your password. If you don't see it, check your Spam folder.
      </div>

      <div class="mar-b-20 ">
        <button mat-button class="width-100 text-c" style="line-height: 42px;"
          (click)="projectType='login';backToLogin()">Back
          To Sign in</button>
      </div>
    </div>
  </div>


</ng-template>

<ng-template #resetPassword>

  <div class="d-f">
    <div class="icon-40 mar-r-20">
      <img src="https://app.atmavaan.com/uploads/{{AppInfo?.logo}}" class="width-100">
    </div>
    <div class="flex flex-d-c" style="line-height: 1.3;">
      <div class="text-c font-18 f-w-500">{{AppInfo?.portal_name}}</div>
      <div class="font-10 f-w-500">{{AppInfo?.tag_line}}</div>
    </div>
  </div>

  <div class="font-20 f-w-500 mar-b-30 pos-r">Reset password</div>
  <!-- Error -->
  <app-loader *ngIf="isCheckingRestLInk"></app-loader>
  <form [formGroup]="resetFormGroup">
    <div
      class="input-bc flex  mar-b-25 width-400 text-field {{!!passwordErrorCallback ? 'shake' : ''}} {{resetFormGroup.get('password')?.value.length > 0 ? 'bg-none':''}}">
      <div class="password-input-container width-100">
        <input style="background: #F6F2E9;border: 0.5px solid #E8A23DB2 !important;" placeholder=" " formControlName="password" autofocus (input)="passwordValid()"
          (focus)="errorMessage='';resetPasswordFocus=true"
          class="pad-10 height-100 text-base {{!passwordErrorCallback ? 'valid' : 'invalid'}} {{resetFormGroup.get('password')?.value.length > 0 ? '':'border-n'}}"
          type="{{passwordOpen ? 'text' : 'password'}}">
        <span class="{{!passwordErrorCallback ? 'valid-c' : 'invalid-c'}} font-s wid-reset-mob">Enter Your New
          Password</span>
        <div class="visibility-icon-container pointer" (click)="passwordOpen=!passwordOpen">
          <div class="material-symbols-outlined icon-20">{{passwordOpen ? 'visibility' : 'visibility_off'}}</div>
        </div>
      </div>
    </div>

    <div
      class="input-bc flex  mar-b-25 width-400 text-field {{!!passwordErrorCallback ? 'shake' : ''}} {{resetFormGroup.get('repassword')?.value.length > 0 ? 'bg-none':''}}">
      <div class="password-input-container width-100">
        <input style="background: #F6F2E9;border: 0.5px solid #E8A23DB2 !important;" placeholder=" " formControlName="repassword"
          class="pad-10 text-base height-100 {{resetFormGroup.get('repassword')?.value.length > 0 ? '':'border-n'}}"
          autofocus (input)="passwordValid()" (focus)="errorMessage='';resetPasswordFocus=true"
          type="{{passwordOpen?'text':'password'}}">
        <span class="{{!passwordErrorCallback ? 'valid-c' : 'invalid-c'}} font-s wid-reset-mob">Re-enter Your
          Password</span>
        <div class="visibility-icon-container pointer" (click)="passwordOpen=!passwordOpen">
          <div class="material-symbols-outlined icon-20">{{passwordOpen ? 'visibility' : 'visibility_off'}}</div>
        </div>
      </div>
    </div>
    <!-- Match case Error-->
    <div class="flex align-c pad-5 ">
      <div
        class="flex align-c justify-c border-r-4 mar-r-10 border border-c {{(passwordMatchError.letter && resetPasswordFocus) ?'success-c':'warn-c'}}"
        style="width: 25px;height: 25px;">
        <mat-icon class="icon-16 pad-r-10">{{passwordMatchError.letter ? 'done':'clear'}} </mat-icon>
      </div>
      <div class="sub-cc">Include both upper and lower case character</div>
    </div>
    <div class="flex align-c pad-5 ">
      <div
        class="flex align-c justify-c border-r-4 mar-r-10 border border-c {{(passwordMatchError.number_symbol && resetPasswordFocus) ?'success-c':'warn-c'}}"
        style="width: 25px;height: 25px;">
        <mat-icon class="icon-16 pad-r-10">{{passwordMatchError.number_symbol ? 'done':'clear'}}</mat-icon>
      </div>
      <div class="sub-cc">Include at least one character or symbol</div>
    </div>

    <div class="flex align-c pad-5  ">
      <div
        class="flex align-c justify-c border-r-4 mar-r-10 border border-c {{(passwordMatchError.len && resetPasswordFocus) ?'success-c':'warn-c'}}"
        style="width: 25px;height: 25px;">
        <mat-icon class="icon-16 pad-r-10">{{passwordMatchError.len ? 'done':'clear'}}</mat-icon>
      </div>
      <div class="sub-cc">Password must be at least 8 characters long.</div>
    </div>

    <div class="flex align-c mar-b-20 pad-5 ">
      <div
        class="flex align-c justify-c border-r-4 mar-r-10 border border-c {{(passwordMatchError.password_match && resetPasswordFocus) ?'success-c':'warn-c'}}"
        style="width: 25px;height: 25px;">
        <mat-icon class="icon-16 pad-r-10">{{passwordMatchError.password_match ? 'done':'clear'}}</mat-icon>
      </div>
      <div class="sub-cc">Ensure both passwords match.</div>
    </div>
    <!-- Match case Error end-->

    <div class="flex align-c justify-space-between mar-b-30">
      <button mat-stroked-button color="primary" class=" pointer" (click)="resetPassowrdTOLoginOTP()">Login with
        OTP</button>
      <button mat-button color="primary" class="white btn-bg width-100px pointer" (click)="changeNewPassword()"
        type="submit" [disabled]="isResetButtonDisabled()">Reset</button>
    </div>

  </form>

</ng-template>


<ng-template #setPassword>

  <div class="d-f">
    <div class="icon-40 mar-r-20">
      <img loading="lazy" src="https://app.atmavaan.com/uploads/{{AppInfo?.logo}}" class="width-100">
    </div>
    <div class="flex flex-d-c" style="line-height: 1.3;">
      <div class="text-c font-18 f-w-500">{{AppInfo?.portal_name}}</div>
      <div class="font-10 f-w-500">{{AppInfo?.tag_line}}</div>
    </div>
  </div>
  <app-loader *ngIf="isCheckingRestLInk"></app-loader>
  <div class="font-20 f-w-500 mar-b-30 pos-r">Create Password</div>
  <!-- Error -->
  <form [formGroup]="setPasswordFormGroup">
    <div
      class="input-bc flex  mar-b-25 width-400 text-field {{!!passwordErrorCallback ? 'shake' : ''}} {{setPasswordFormGroup.get('password')?.value.length > 0 ? 'bg-none':''}}">
      <div class="password-input-container width-100">
        <input  style="background: #F6F2E9;border: 0.5px solid #E8A23DB2 !important;"placeholder=" " formControlName="password" autofocus (input)="createpasswordValid()"
          (focus)="errorMessage='';resetPasswordFocus=true"
          class="pad-10 height-100 text-base {{!passwordErrorCallback ? 'valid' : 'invalid'}} {{setPasswordFormGroup.get('password')?.value.length > 0 ? '':'border-n'}}"
          type="{{passwordOpen ? 'text' : 'password'}}">
        <span class="{{!passwordErrorCallback ? 'valid-c' : 'invalid-c'}} font-s wid-reset-mob">Enter Your
          Password</span>
        <div class="visibility-icon-container pointer" (click)="passwordOpen=!passwordOpen">
          <div class="material-symbols-outlined icon-20">{{passwordOpen ? 'visibility' : 'visibility_off'}}</div>
        </div>
      </div>
    </div>
    <!-- Match case Error-->
    <div class="flex align-c pad-5 ">
      <div
        class="flex align-c justify-c border-r-4 mar-r-10 border border-c {{(passwordMatchError.letter && resetPasswordFocus) ?'success-c':'warn-c'}}"
        style="width: 25px;height: 25px;">
        <mat-icon class="icon-16 pad-r-10">{{passwordMatchError.letter ? 'done':'clear'}} </mat-icon>
      </div>
      <div class="sub-cc">Include both upper and lower case character</div>
    </div>
    <div class="flex align-c pad-5 ">
      <div
        class="flex align-c justify-c border-r-4 mar-r-10 border border-c {{(passwordMatchError.number_symbol && resetPasswordFocus) ?'success-c':'warn-c'}}"
        style="width: 25px;height: 25px;">
        <mat-icon class="icon-16 pad-r-10">{{passwordMatchError.number_symbol ? 'done':'clear'}}</mat-icon>
      </div>
      <div class="sub-cc">Include at least one character or symbol</div>
    </div>

    <div class="flex align-c pad-5   mar-b-20">
      <div
        class="flex align-c justify-c border-r-4 mar-r-10 border border-c {{(passwordMatchError.len && resetPasswordFocus) ?'success-c':'warn-c'}}"
        style="width: 25px;height: 25px;">
        <mat-icon class="icon-16 pad-r-10">{{passwordMatchError.len ? 'done':'clear'}}</mat-icon>
      </div>
      <div class="sub-cc">Password must be at least 8 characters long.</div>
    </div>

    <!-- Match case Error end-->

    <div class="flex align-c justify-space-between mar-b-30">
      <button mat-stroked-button color="primary" class=" pointer" (click)="resetPassowrdTOLoginOTP()">Login with
        OTP</button>
      <button mat-button color="primary" class="white btn-bg width-130px pointer" (click)="setCreatePassword()"
        type="submit" [disabled]="setPasswordVaildChecker()">Create Password</button>
    </div>

  </form>

</ng-template>

<ng-template #resetSuccessTemplate>

  <div>
    <div class="d-f" style="position: relative;left: -40px;">
      <div class="icon-40 mar-r-20">
        <img src="https://app.atmavaan.com/uploads/{{AppInfo?.logo}}" class="width-100">
      </div>
      <div class="flex flex-d-c" style="line-height: 1.3;">
        <div class="text-c font-18 f-w-500">{{AppInfo?.portal_name}}</div>
        <div class="font-10 f-w-500">{{AppInfo?.tag_line}}</div>
      </div>
    </div>

    <div class="flex  align-c justify-c flex-d-c" style="position: relative;top: 25%;">
      <div class="mar-b-30"><img src="{{filePath}}Group_34449_svg_453_2024-01-31_13:57:12.svg" alt="">
      </div>
      <div class="text-a-c font-14 sub-cc mar-b-10">Your password has been successfully reset.</div>
      <div class="text-a-c font-14 sub-cc mar-b-20">You can now login with your new password!</div>

      <div class="mar-b-20 ">
        <button mat-button class="width-100 text-c" style="line-height: 42px;"
          (click)="projectType='login';backToLogin()">
          Back To Sign in</button>
      </div>
    </div>
  </div>

</ng-template>

<ng-template #invalidToken>
  <div class="pad-20 text-a-c pos-r" style="top: 13%;">
    <img src="https://app.atmavaan.com/uploads/Group_34450_svg_454_2024-03-22_04:35:38.svg" width="50px"
      class="mar-b-10">
    <div class="font-18 head-c pad-tb-20">Password Reset Link Expired</div>
    <div class="font-14 head-c mar-b-25">This link has expired. Please click this button to receive a new password
      reset link.</div>

    <button (click)="errorMessage='';forgetPassword()" mat-flat-button class="mar-b-20 width-230 btn-bg white">
      Request a New Reset Link
    </button>

    <button mat-button color="primary" class="width-230" (click)="projectType='login';backToLogin()">Back
      To Login</button>
  </div>
</ng-template>



<ng-template #PasswordExit>
  <div class="pad-20 text-a-c pos-r" style="top: 13%;">
    <img loading="lazy" src="https://app.atmavaan.com/uploads/Group_34450_svg_454_2024-03-22_04:35:38.svg" width="50px"
      class="mar-b-10">
    <div class="font-18 head-c pad-tb-20">{{errorMessage}}</div>
    <div class="font-14 head-c mar-b-25">Please try login or click this button to receive a new password
      reset link.</div>

    <button (click)="errorMessage='';forgetPassword()" mat-flat-button class="mar-b-20 width-230 btn-bg white">
      Request a New Reset Link
    </button>
    <button mat-button color="primary" class="width-230" (click)="projectType='login';backToLogin()">Back
      To Login</button>
  </div>
</ng-template>


<ng-template #invalidPasswordlinkTemplate>
  <div class="pad-20 text-a-c pos-r" style="top: 13%;">
    <img loading="lazy" src="https://app.atmavaan.com/uploads/Group_34450_svg_454_2024-03-22_04:35:38.svg" width="50px"
      class="mar-b-10">
    <div class="font-18 head-c pad-tb-20">{{errorMessage}}</div>
    <button mat-button color="primary" class="width-230" (click)="projectType='login';backToLogin()">Back
      To Login</button>
  </div>
</ng-template>

